import type { AppState } from '../types';
import { bus } from '../events';

/**
 * Store da aplicação.
 *
 * >>> Esta é a única camada atada ao navegador. Quando a API entrar, `loadPersisted`
 * e `persist` dão lugar ao cliente HTTP; o resto do front continua lendo `getState()`
 * e chamando `commit()` depois de alterar.
 */
const KEY = 'rdlf.state.v1';

let state: AppState | null = null;

export function getState(): AppState {
  if (!state) throw new Error('Store ainda não inicializado');
  return state;
}

export function setState(next: AppState): void {
  state = next;
}

export function persist(): void {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* modo privado */ }
}

export function loadPersisted(): AppState | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as AppState;
  } catch { /* corrompido: recomeça */ }
  return null;
}

/** Persiste e avisa as features para redesenhar. */
export function commit(): void {
  persist();
  bus.emit('state');
}

export const uid = (): string => Math.random().toString(36).slice(2, 10);
